module.exports = __webpack_public_path__ + "static/media/cv.94882f3a.svg";